export function findFirstItemInArrayFromTop<T>(inputArray: T[], assertionCallback: (item: T) => boolean) {
  for (let index = 0; index < inputArray.length; index++) {
    if (assertionCallback(inputArray[index])) {
      return index;
    }
  }
  return 0;
}

export function findFirstItemInArrayFromBottom<T>(inputArray: T[], assertionCallback: (item: T) => boolean) {
  for (let index = inputArray.length - 1; index >= 0; index--) {
    if (assertionCallback(inputArray[index])) {
      return index;
    }
  }
  return inputArray.length - 1;
}

export function areEqualArrays<T>(baseArray: T[] | null, targetArray: T[] | null, checkerFunction: (base: T, target: T) => boolean) {
  if (baseArray === targetArray) {
    return true;
  }
  if (baseArray == null || targetArray == null) {
    return false;
  }
  if (baseArray.length !== targetArray.length) {
    return false;
  }
  for (let i = 0; i < baseArray.length; ++i) {
    if (!checkerFunction(baseArray[i], targetArray[i])) {
      return false;
    }
  }
  return true;
}

export function lookupItemsAroundIndex<T>(array: T[], targetIndex: number) {
  const currentItem = array[targetIndex];
  const previousItem = targetIndex - 1 >= 0 ? array[targetIndex - 1] : null;
  const nextItem = targetIndex + 1 < array.length ? array[targetIndex + 1] : null;
  return { currentItem, previousItem, nextItem };
}

export function removeItemFromArray<T>(array: T[], targetItem: T) {
  const index = array.indexOf(targetItem);
  if (index > -1) {
    array.splice(index, 1);
  }
  return array;
}

export function dedudplicateArray<T>(arr: T[]) {
  return Array.from(new Set(arr));
}

export function deduplicateValues<T = string>(entries: T[]): T[] {
  return entries.filter((tag, index, array) => array.findIndex((entry) => entry == tag) == index).filter(Boolean);
}

export function deduplicateArrayObjects<T = Record<string, unknown>>(entries: T[], key: keyof T): T[] {
  return entries
    .filter((baseItem, index, array) => array.findIndex((lookupItem) => lookupItem[key] == baseItem[key]) == index)
    .filter(Boolean);
}

export function extractStatsFromNumberedArray(arr: number[]): { min: number; max: number; average: number } {
  if (!arr.length) {
    return { max: 0, min: 0, average: 0 };
  }
  let total = 0;
  let max = Number.MIN_SAFE_INTEGER;
  let min = Number.MAX_SAFE_INTEGER;
  arr.forEach((value) => {
    if (value <= min) {
      min = value;
    }
    if (value >= max) {
      max = value;
    }
    total += value;
  });
  const average = total / arr.length;
  return { min, max, average };
}

export function arraysHaveTheSameValues<T>(inputA: T[], inputB: T[]) {
  if (inputA.length !== inputB.length) {
    return false;
  }
  inputA = inputA.sort();
  inputB = inputB.sort();
  return inputA.every((val, index) => val === inputB[index]);
}

export function firstItemFromArray<T>(values: Array<T>): T | null {
  return values.length > 0 ? values[0] : null;
}

export function getRandomSubarray<T>(arr: T[], size: number): T[] {
  const shuffled = arr.slice(0); // Clone the array to avoid modifying the original
  let i = arr.length;
  let temp: T;
  let index: number;
  // While there remain elements to shuffle…
  while (i--) {
    // Pick a remaining element…
    index = Math.floor(Math.random() * (i + 1));
    // And swap it with the current element.
    temp = shuffled[i];
    shuffled[i] = shuffled[index];
    shuffled[index] = temp;
  }
  // Return the first `size` elements after shuffling
  return shuffled.slice(0, size);
}
